import React, { useEffect, useRef, useState } from "react";

import { useForm } from "../useForm";

import SelectMenu from "../../controls/SelectMenu";
import {
  convertToDefEventPara,
  makeBeepNoise,
  orderStatusOptions,
  updateObjectInArray,
  isSunDistribution,
} from "../../../shared/utility";
import DeleteConfirmationForm from "../DeleteConfirmationForm";
import Input from "../../controls/Input";
import QuickScanAddToShippingForm from "./QuickScanAddToShippingForm";
import { Accordion, AccordionTab } from "primereact/accordion";
import OrderItemsForShippingV2 from "./OrderItemsForShippingV2";
import { Checkbox } from 'primereact/checkbox';

const initialFValues = {
  id: 0,
  customer_id: 0,
  subtotal_dollar_amount: 0,
  total_dollar_amount: 0,
  order_id: 0,
  orderItems: [],
  sun_customer_po_number: "",
  pallet_count: "",
  total_freight_weight: "",
  appointment_number: "",
  temperature_recorder_number: "",
};

export default function ShippingFormV2(props) {
  const {
    orders,
    onFetchOrderItems,
    isEdit,
    shipping,
    setEmptyModelOpen,
    showErrorModal,
    onFetchPackagedItemByBarcode,
    updateShippingApiCall,
    createShippingApiCall,
    addPackagedItemToOrderItem,
    deleteShippingItemApiCall,
    addSkidLabelToOrderItem,
    employeeOptions,
    deleteShipping,
    printShipping,
    quickAddPackagedItemToOrderItem,
    deleteQuickScanShippingItemByLot,
    exportOrderForNetSuite,
    getOrderItemsOnly,
    rowDetails,
    fetchRowDetails,
    loadingRows,
    sunCustomers,
    sendShippingToQuickbooks,
    printShippingLabel,
    calculateFreightWeight,
    generateBolDocument,
    generateBolNumber
  } = props;

  const [barcodeScanInProgress, setBarcodeScanInProgress] = useState(false);
  const [quickScan, setQuickScan] = useState(false);

  const barcodeInputRef = useRef(null);

  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    temp.order_id = null;
    if (values.order_id === 0) {
      temp.order_id = "Please fill out field.";
    }

    setErrors({
      ...temp,
    });

    if (fieldValues === values) {
      return Object.values(temp).every((x) => x === null);
    }
  };

  const { values, setValues, errors, setErrors, handleInputChange } = useForm(
    initialFValues,
    false,
    validate
  );

  useEffect(() => {
    if (shipping) {
      const shippingCopy = {
        ...shipping,
        status: orderStatusOptions.filter(
          (option) => option.value == shipping.status
        )[0],
        is_prepaid: shipping.is_prepaid === "1" ? true : false,
      };
      setValues(shippingCopy);
    }
  }, [shipping]);

  function findIndexForOrderItem(product_id) {
    return values.orderItems.findIndex(
      (element) => element.product_id === product_id
    );
  }

  const updateShipping = () => {
    if (validate()) {
      updateShippingApiCall(values);
    }
  };

  const createShipping = () => {
    if (isEdit) {
      updateShipping();
    } else {
      if (validate()) {
        createShippingApiCall(values);
      }
    }
  };

  const onCalculateFreightWeight = async () => {
    const callResult = await calculateFreightWeight(values.pallet_count);
    if (callResult.success) {
      setValues({
        ...values,
        total_freight_weight: callResult.data.total_freight_weight,
      });
    }
  };

  const normalItemScanned = async function (packagedItem, itemIndex) {
    const orderItems = [...values.orderItems];
    const orderItem = orderItems[itemIndex];

    // const packageAlreadyScanned = orderItem.shippingItems.findIndex(
    //   (element) => {
    //     return element.id === packagedItem.id;
    //   }
    // );
    // if (packageAlreadyScanned >= 0) {
    //   showErrorModal("Item already scanned");
    //   return;
    // }

    let callResult = { success: false };
    if (isEdit) {
      callResult = await addPackagedItemToOrderItem(
        values.id,
        orderItem,
        packagedItem
      );
    }

    if (callResult.success || !isEdit) {
      let newShippingItems = [packagedItem];
      if (orderItem.shippingItems) {
        newShippingItems = [...orderItem.shippingItems, packagedItem];
      }
      const shipped_amount = orderItem.shipped_amount
        ? parseFloat(orderItem.shipped_amount)
        : 0;

      const newAmountBeingShipped =
        orderItem.selling_unit_of_measure === "Kg"
          ? parseFloat(packagedItem.packing_size)
          : 1;

      const orderItemBeingEdited = {
        ...orderItem,
        shipped_amount: shipped_amount + newAmountBeingShipped,
        shippingItems: newShippingItems,
      };
      var payload = {
        index: itemIndex,
        item: orderItemBeingEdited,
      };
      const newOrderItems = updateObjectInArray(orderItems, payload);
      setValues({
        ...values,
        orderItems: newOrderItems,
        scanned_box_label: "",
      });
    }
  };

  const skidLabelScanned = async function (packagedItems, itemIndex) {
    const orderItems = [...values.orderItems];
    const orderItem = orderItems[itemIndex];

    var newItems = packagedItems.packaged_item.filter(function (obj) {
      return (
        orderItem.shippingItems.findIndex((item) => item.id === obj.id) === -1
      );
    });

    let callResult = { success: false };
    if (isEdit) {
      callResult = await addSkidLabelToOrderItem(
        values.id, // this is the shipping id
        orderItem.id,
        newItems.map((item) => item.id)
      );
    }

    if (callResult.success || !isEdit) {
      let newShippingItems = [...newItems];
      if (orderItem.shippingItems) {
        newShippingItems = [...orderItem.shippingItems, ...newItems];
      }
      const shipped_amount = orderItem.shipped_amount
        ? parseInt(orderItem.shipped_amount)
        : 0;

      const orderItemBeingEdited = {
        ...orderItem,
        shipped_amount: shipped_amount + packagedItems.count,
        shippingItems: newShippingItems,
      };
      var payload = {
        index: itemIndex,
        item: orderItemBeingEdited,
      };
      const newOrderItems = updateObjectInArray(orderItems, payload);
      setValues({
        ...values,
        orderItems: newOrderItems,
        scanned_box_label: "",
      });
    }
  };

  const quickAddScannedItemAmount = async function (newValues, orderItemId) {
    const callResult = await quickAddPackagedItemToOrderItem({
      ...newValues,
      order_item_id: orderItemId,
    });
    if (callResult.success) {
      const resultOrderItems = await getOrderItemsOnly();
      if (resultOrderItems.success) {
        setEmptyModelOpen({
          childComponent: null,
          open: false,
        });

        setValues({
          ...values,
          orderItems: resultOrderItems.data,
          scanned_box_label: "",
        });
      }
    }
  };

  /*
   * The edit button will open the popup again and display the same information.
   * If its new shipping folow, on enter it will query the items again.
   * If the shipping is being edited, then it will remove all quick_scan items for that shipping and query new ones
   */
  const openQuickScanPopupWithFetchLatest = async function (item) {
    // let callResult = await onFetchPackagedItemByBarcode(item);
    const orderItemIndex = findIndexForOrderItem(item.product_id);
    console.log("orderItemIndex", orderItemIndex);
    openQuickScanPopup(item, orderItemIndex, item.shippingItems.length);
  };

  const openQuickScanPopup = (item, orderItemIndex, existingQuantity) => {
    const orderItems = [...values.orderItems];
    const orderItem = orderItems[orderItemIndex];

    var currQuantity = 0;
    if (existingQuantity < 1 || typeof existingQuantity === "undefined") {
    } else {
      currQuantity = existingQuantity;
    }

    setEmptyModelOpen({
      childComponent: (
        <QuickScanAddToShippingForm
          confirmAction={(newValues) =>
            quickAddScannedItemAmount(newValues, orderItem.id)
          }
          item={item}
          setOpen={setEmptyModelOpen}
          currQuantity={currQuantity}
          orderQuantity={orderItem.quantity}
          selling_unit_of_measure={orderItem.selling_unit_of_measure}
        />
      ),
      open: true,
    });
  };

  const handleBarcodeScan = async function (scannedBarcode) {
    setValues({
      ...values,
      scanned_box_label: "",
    });
    if (barcodeInputRef.current) {
      barcodeInputRef.current.focus();
    }
    let callResult = await onFetchPackagedItemByBarcode(scannedBarcode);
    if (callResult.success) {
      makeBeepNoise();
      const packagedItem = callResult.data;
      var prodIdToSearch = packagedItem.packaged_item.product_id;
      if (packagedItem.is_skid_label) {
        if (packagedItem.packaged_item.length > 0) {
          prodIdToSearch = packagedItem.packaged_item[0].product_id;
        } else {
          showErrorModal("No items for skid label");
          return;
        }
      }
      const itemIndex = findIndexForOrderItem(prodIdToSearch);

      if (itemIndex >= 0) {
        if (packagedItem.is_skid_label) {
          skidLabelScanned(packagedItem, itemIndex);
        } else if (quickScan) {
          openQuickScanPopup(packagedItem.packaged_item, itemIndex);
        } else {
          normalItemScanned(packagedItem.packaged_item, itemIndex);
        }
      } else {
        showErrorModal("Item not in order");
      }
    } else {
      showErrorModal("We could not find that item.");
    }
  };

  const onDeleteQuickScannedLotItem = async function (item) {
    const product_lot = item.product_lot;
    const product_id = item.product_id;
    const order_item_id = item.order_item_id;
    const amountForLot = item.shippingItems.length;
    var onItemDeleted = { success: false };
    console.log("item", item);
    console.log("product_id", product_id);

    const itemIndex = findIndexForOrderItem(product_id);

    if (isEdit) {
      onItemDeleted = await deleteQuickScanShippingItemByLot({
        product_lot: product_lot,
        shipping_id: shipping.id,
        order_item_id: order_item_id,
        lot_quantity: item.shippingItems.length,
      });
    }
    console.log(onItemDeleted);

    if (onItemDeleted.success || !isEdit) {
      if (itemIndex >= 0) {
        console.log("itemIndex", itemIndex);
        const orderItems = [...values.orderItems];
        const orderItem = orderItems[itemIndex];

        const filteredItems = orderItem.shippingItems.filter((element) => {
          return element.product_lot !== product_lot;
        });
        const orderItemBeingEdited = {
          ...orderItem,
          shipped_amount: parseInt(orderItem.shipped_amount) - amountForLot,
          shippingItems: filteredItems,
        };
        var payload = {
          index: itemIndex,
          item: orderItemBeingEdited,
        };
        const newOrderItems = updateObjectInArray(orderItems, payload);
        setValues({ ...values, orderItems: newOrderItems });
        setEmptyModelOpen({
          childComponent: null,
          open: false,
        });
      }
    }
  };

  const makeDeleteShippingItemApiCall = async function (
    id,
    barcode,
    product_id
  ) {
    var onItemDeleted = { success: false };

    const itemIndex = findIndexForOrderItem(product_id);

    if (isEdit) {
      onItemDeleted = await deleteShippingItemApiCall(id);
    }

    if (onItemDeleted.success || !isEdit) {
      if (itemIndex >= 0) {
        const orderItems = [...values.orderItems];
        const orderItem = orderItems[itemIndex];

        const filteredItems = orderItem.shippingItems.filter((element) => {
          return element.shipping_barcode !== barcode;
        });
        const orderItemBeingEdited = {
          ...orderItem,
          shipped_amount: parseInt(orderItem.shipped_amount) - 1,
          shippingItems: filteredItems,
        };
        var payload = {
          index: itemIndex,
          item: orderItemBeingEdited,
        };
        const newOrderItems = updateObjectInArray(orderItems, payload);
        setValues({ ...values, orderItems: newOrderItems });
        setEmptyModelOpen({
          childComponent: null,
          open: false,
        });
      }
    }
  };

  const askDeleteShippingItem = function (item) {
    let text = item.product_name;
    if (item.is_lot) {
      text = item.product_lot;
    }

    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => {
            if (item.is_lot) {
              onDeleteQuickScannedLotItem(item);
            } else {
              makeDeleteShippingItemApiCall(
                item.id,
                item.shipping_barcode,
                item.product_id
              );
            }
          }}
          message={`Are you sure you want to delete ${text}?`}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  return (
    <div className="grid grid-col-1 sm:grid-cols-3 gap-3 h-full">
      <div className="sm:col-span-2 card-custom p-3 order-2 sm:order-1">
        <div className="grid grid-cols-1 sm:grid-cols-4 gap-1">
          <div className="sm:col-span-3">
            <div className="space-x-2 mb-1">
              <label
                htmlFor="scanned_box_label"
                className={"text-sm block font-medium text-gray-900"}
              >
                Scan barcode
              </label>
            </div>
            <input
              placeholder="Scan box label"
              name="scanned_box_label"
              disabled={barcodeScanInProgress}
              ref={barcodeInputRef}
              onChange={handleInputChange}
              value={values.scanned_box_label}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleBarcodeScan(e.target.value);
              }}
              type="search"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
          </div>
          <div className="flex my-auto">
            <input
              id="quick_scan"
              aria-describedby="selectAllBox"
              name="quick_scan"
              type="checkbox"
              checked={values.quick_scan}
              className="mt-1 mr-2 h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
              onClick={(e) => setQuickScan(e.target.checked)}
            />
            Quick Scan
          </div>
        </div>
        <OrderItemsForShippingV2
          askDeleteShippingItem={askDeleteShippingItem}
          orderItems={values.orderItems}
          openQuickScanPopupWithFetchLatest={openQuickScanPopupWithFetchLatest}
          rowDetails={rowDetails}
          fetchRowDetails={fetchRowDetails}
          loadingRows={loadingRows}
          printShippingLabel={printShippingLabel}
        />
      </div>
      <div className="space-y-5 order-1 sm:order-2">
        <Accordion activeIndex={0}>
          <AccordionTab header="Shipping Information">
            <div className="card-custom p-3 space-y-2">
              <SelectMenu
                handleInputChange={(e) => {
                  handleInputChange(
                    convertToDefEventPara("order_id", e.target.value)
                  );
                  onFetchOrderItems(e.target.value.value);
                }}
                name="order_id"
                options={orders}
                defaultValue={isEdit ? shipping.order : null}
                title={"Order to ship"}
                disabled={isEdit}
                error
              />

              <SelectMenu
                handleInputChange={handleInputChange}
                name="created_by"
                options={employeeOptions}
                defaultValue={isEdit ? shipping.created_by : null}
                title={"Employee"}
                error={errors.created_by}
                showLabel={true}
              />

              <Input
                label="Invoice #"
                name="invoice_number"
                onChange={handleInputChange}
                value={values.invoice_number}
                labelOn={true}
                type="text"
                      autoComplete="off"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                error={errors.invoice_number}
              />

              <Input
                label="Seal #"
                name="seal_number"
                onChange={handleInputChange}
                value={values.seal_number}
                labelOn={true}
                type="text"
                      autoComplete="off"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                error={errors.seal_number}
              />

              <SelectMenu
                handleInputChange={handleInputChange}
                name="status"
                options={orderStatusOptions.filter(
                  (option) => option.value !== -1
                )}
                value={values.status}
                title={"Status"}
                error={errors.status}
                showLabel={true}
              />

              <div className="flex flex-wrap gap-2 py-4">
                {values.id > 0 && (
                  <button
                    type="button"
                    className="inline-flex items-center justify-center rounded-lg bg-gray-500 px-3.5 py-2 text-sm font-semibold text-white shadow-md transition-all duration-200 hover:bg-gray-600 hover:shadow-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600"
                    onClick={() => printShipping()}
                  >
                    Print
                  </button>
                )}

                <button
                  type="button"
                  className="inline-flex items-center justify-center rounded-lg bg-main-purple px-3.5 py-2 text-sm font-semibold text-white shadow-md transition-all duration-200 hover:bg-indigo-600 hover:shadow-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  onClick={createShipping}
                >
                  {values.id > 0 ? "Save" : "Submit"}
                </button>

                {values.id > 0 && (
                  <button
                    type="button"
                    className="inline-flex items-center justify-center rounded-lg bg-emerald-600 px-3.5 py-2 text-sm font-semibold text-white shadow-md transition-all duration-200 hover:bg-emerald-700 hover:shadow-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-emerald-600"
                    onClick={exportOrderForNetSuite}
                  >
                    Export
                  </button>
                )}

                {values.id > 0 && (
                  <button
                    type="button"
                    className="inline-flex items-center justify-center rounded-lg bg-rose-600 px-3.5 py-2 text-sm font-semibold text-white shadow-md transition-all duration-200 hover:bg-rose-700 hover:shadow-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-rose-700"
                    onClick={deleteShipping}
                  >
                    Delete
                  </button>
                )}
              </div>
            </div>
          </AccordionTab>

          {isSunDistribution() && (
          <AccordionTab header="Sun Distribution">
                <div className="card-custom p-3 space-y-3">
                  <div>
                    <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wide">
                      Sun Distribution Details
                    </h3>
                    <p className="text-xs text-gray-500">
                      Sun Distribution shipment information and actions.
                    </p>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <SelectMenu
                      handleInputChange={handleInputChange}
                      name="sun_customer"
                      options={sunCustomers}
                      value={values.sun_customer}
                      title={"SUN Customer"}
                      error={errors.sun_customer}
                      showLabel={true}
                      parentClass="col-span-2"
                    />

                    <Input
                      label="Customer PO Number"
                      name="sun_customer_po_number"
                      tooltip="You need to enter manually."
                      onChange={handleInputChange}
                      value={values.sun_customer_po_number}
                      labelOn={true}
                      type="text"
                      autoComplete="off"
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                    />

              <div className="space-y-1">
                    <Input
                      label="BOL Number"
                      name="sun_bol_number"
                      tooltip="Will be generated automatically."
                      onChange={handleInputChange}
                      value={values.sun_bol_number}
                      labelOn={true}
                      type="text"
                      autoComplete="off"
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                    />
                    <button type="button" className="
                    inline-flex items-center justify-center rounded-lg bg-main-purple px-3.5 py-1 text-sm font-semibold text-white shadow-md transition-all 
                    duration-200 hover:bg-indigo-600 hover:shadow-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600" 
                    onClick={() => {
                      generateBolNumber();
                    }}>
                      Generate BOL Number
                    </button>
                    </div>

                  <Input
                      label="Appointment Number"
                      name="appointment_number"
                      tooltip="You need to enter manually."
                      onChange={handleInputChange}
                      value={values.appointment_number}
                      labelOn={true}
                      type="text"
                      autoComplete="off"
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                    />

                    <Input
                      label="Pallet Count"
                      name="pallet_count"
                      tooltip="Will be used to calculate total weight."
                      onChange={handleInputChange}
                      value={values.pallet_count}
                      labelOn={true}
                      type="number"
                      min={0}
                      autoComplete="off"
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                    />

                  <Input
                      label="Chep Pallet Count"
                      name="chep_pallet_count"
                      onChange={handleInputChange}
                      value={values.chep_pallet_count}
                      labelOn={true}
                      type="number"
                      min={0}
                      autoComplete="off"
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                    />

                <Input
                      label="Carrier Name"
                      name="carrier_name"
                      onChange={handleInputChange}
                      value={values.carrier_name}
                      labelOn={true}
                      type="text"
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                    />

                    <Input
                      label="Total Freight Weight"
                      name="total_freight_weight"
                      onChange={handleInputChange}
                      value={values.total_freight_weight}
                      labelOn={true}
                      type="text"
                      autoComplete="off"
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                    />

                    <Input
                      label="Temperature Recorder Number"
                      name="temperature_recorder_number"
                      onChange={handleInputChange}
                      value={values.temperature_recorder_number}
                      labelOn={true}
                      type="text"
                      autoComplete="off"
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                    />
                    
                    <Input
                      label="Sales Rep"
                      name="sun_sales_rep_name"
                      onChange={handleInputChange}
                      value={values.sun_sales_rep_name}
                      labelOn={true}
                      disabled={true}
                      type="text"
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                    />
                  </div>

                  <div>
                  <div className="flex align-items-center">
        <Checkbox inputId="is_prepaid" name="is_prepaid" value="Is Prepaid"  onChange={e => setValues({ ...values, is_prepaid: e.checked })} checked={values.is_prepaid} />
        <label htmlFor="is_prepaid" className="ml-2">Is Prepaid</label>
    </div>

    {
      !values.is_prepaid ? 
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-2">
                    <Input
                      label="WFP"
                      name="wfp_text"
                      onChange={handleInputChange}
                      value={values.wfp_text}
                      labelOn={true}
                      type="text"
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                    />

                    <Input
                      label="WFP Load ID Number"
                      name="wfp_load_id_number"
                      onChange={handleInputChange}
                      value={values.wfp_load_id_number}
                      labelOn={true}
                      type="text"
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                    />

<Input
                      label="WFP Pickup Date"
                      name="wfp_pickup_date"
                      onChange={handleInputChange}
                      value={values.wfp_pickup_date}
                      labelOn={true}
                      type="text"
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                    />

<Input
                      label="WFP Gate In/Out Times"
                      name="wfp_gate_in_gate_out_times"
                      onChange={handleInputChange}
                      value={values.wfp_gate_in_gate_out_times}
                      labelOn={true}
                      type="text"
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                    />


                    </div>
      
      : null}
                  </div>
                  <div className="flex flex-wrap gap-2 pt-2">
                    {values.id > 0 && (
                      <button
                        type="button"
                        className="inline-flex items-center justify-center rounded-lg bg-gray-500 px-3.5 py-2 text-sm font-semibold text-white shadow-md transition-all duration-200 hover:bg-gray-600 hover:shadow-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600"
                        onClick={() => printShipping()}
                      >
                        Print
                      </button>
                    )}

                    <button
                      type="button"
                      className="inline-flex items-center justify-center rounded-lg bg-main-purple px-3.5 py-2 text-sm font-semibold text-white shadow-md transition-all duration-200 hover:bg-indigo-600 hover:shadow-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                      onClick={createShipping}
                    >
                      {values.id > 0 ? "Save" : "Submit"}
                    </button>

                    {values.id > 0 && (
                      <>
                        {
                          values.sun_quickbooks_po_id > 0 ? 
                          <div className="flex flex-wrap gap-2">
                             <a
                          href={`https://qbo.intuit.com/app/purchaseorder?txnId=${values.sun_quickbooks_po_id}`}
                          target="_blank"
                          className="inline-flex items-center justify-center rounded-lg bg-green-600 px-3.5 py-2 text-sm font-semibold text-white shadow-md transition-all duration-200 hover:bg-green-700 hover:shadow-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
                        >
                          View PO
                        </a>
                        <a
                          href={`https://qbo.intuit.com/app/invoice?txnId=${values.sun_quickbooks_invoice_id}`}
                          target="_blank"
                          className="inline-flex items-center justify-center rounded-lg bg-green-600 px-3.5 py-2 text-sm font-semibold text-white shadow-md transition-all duration-200 hover:bg-green-700 hover:shadow-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
                        >
                          View Invoice
                        </a>
                          </div>
                          :<button
                          type="button"
                          className="inline-flex items-center justify-center rounded-lg bg-sky-600 px-3.5 py-2 text-sm font-semibold text-white shadow-md transition-all duration-200 hover:bg-sky-700 hover:shadow-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-600"
                          onClick={sendShippingToQuickbooks}
                        >
                          Send to QB
                        </button>
                        }
                        <button
                          type="button"
                          className="inline-flex items-center justify-center rounded-lg bg-amber-600 px-3.5 py-2 text-sm font-semibold text-white shadow-md transition-all duration-200 hover:bg-amber-700 hover:shadow-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber-600"
                          onClick={onCalculateFreightWeight}
                        >
                          Calculate Weight
                        </button>
                        <button
                          type="button"
                          className="inline-flex items-center justify-center rounded-lg bg-slate-700 px-3.5 py-2 text-sm font-semibold text-white shadow-md transition-all duration-200 hover:bg-slate-800 hover:shadow-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-700"
                          onClick={generateBolDocument}
                        >
                          BOL
                        </button>
                      </>
                    )}
                  </div>
                </div>
          </AccordionTab>
             )}
        </Accordion>
      </div>
    </div>
  );
}
